export const blockIconsHomeNestEcoLeafNew = (
	<span className='material-symbols-outlined'>nest_eco_leaf</span>
);
